import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";

import { App } from "@/app/App";
import { startErrorReporting } from "@/observability/errorReporting";
import "@/styles/global.css";

// Not awaited: the app renders whether or not reporting starts. A failed config request
// stays visible as an unhandled rejection in the console rather than being swallowed.
void startErrorReporting();

const container = document.getElementById("root");
if (container === null) {
  throw new Error('Root element "#root" is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The pre-hydration splash in index.html has done its job. Removed rather than hidden
// so it cannot sit on top of the app if a stylesheet fails to load.
document.getElementById("k-splash")?.remove();
